var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 126 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#00c9db;}.cls-2{fill:url(#linear-gradient);}.cls-3{fill:url(#linear-gradient-2);}.cls-4{fill:url(#linear-gradient-3);}.cls-5{fill:url(#radial-gradient);}.cls-6{fill:url(#radial-gradient-2);}.cls-7{fill:url(#radial-gradient-3);}.cls-8{fill:url(#linear-gradient-4);}.cls-9{fill:url(#radial-gradient-4);}.cls-10{fill:url(#linear-gradient-5);}.cls-11{fill:url(#radial-gradient-5);}.cls-12{fill:url(#linear-gradient-6);}.cls-13{fill:url(#linear-gradient-7);}.cls-14{fill:url(#radial-gradient-6);}.cls-15{fill:url(#linear-gradient-8);}.cls-16{fill:url(#radial-gradient-7);}.cls-17{fill:url(#linear-gradient-9);}.cls-18{fill:url(#linear-gradient-10);}.cls-19{fill:url(#linear-gradient-11);}.cls-20{fill:url(#linear-gradient-12);}.cls-21{fill:url(#linear-gradient-13);}.cls-22{fill:url(#linear-gradient-14);}.cls-23{fill:url(#linear-gradient-15);}.cls-24{fill:url(#linear-gradient-16);}.cls-25{fill:url(#radial-gradient-8);}.cls-26{fill:url(#linear-gradient-17);}.cls-27{fill:url(#radial-gradient-9);}.cls-28{fill:url(#linear-gradient-18);}.cls-29{fill:url(#linear-gradient-19);}.cls-30{fill:url(#radial-gradient-10);}.cls-31{fill:#f1f1f8;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 2742.034,
    y1: 3724.194,
    x2: 2735.444,
    y2: 3723.094,
    gradientTransform: "matrix(0.052, -0.999, -0.999, -0.052, 3609.112, 2948.242)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f0584b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c73f3d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 2725.771,
    y1: 3722.306,
    x2: 2746.462,
    y2: 3722.306,
    gradientTransform: "matrix(0.052, -0.999, -0.999, -0.052, 3609.112, 2948.242)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fcba39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d96d2d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 2725.738,
    y1: 3721.847,
    x2: 2746.462,
    y2: 3721.847,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 2749.023,
    cy: 3755.426,
    r: 14.151,
    gradientTransform: "matrix(0.053, -1.037, -1.029, -0.054, 3735.973, 3073.79)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f9b314"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ec5222"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: 3671.495,
    cy: 3963.387,
    r: 14.157,
    gradientTransform: "matrix(1.002, 0, 0, -1.002, -0.138, 40.036)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-3",
    cx: 33.845,
    cy: 21.328,
    r: 0.352,
    gradientTransform: "matrix(1.002, 0, 0, -1.002, -0.138, 40.036)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 2725.599,
    y1: 3721.922,
    x2: 2746.542,
    y2: 3721.922,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-4",
    cx: 34.415,
    cy: 20.072,
    r: 0.125,
    gradientTransform: "matrix(1.002, 0, 0, -1.002, -0.138, 40.036)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 2725.589,
    y1: 3723.66,
    x2: 2746.548,
    y2: 3723.66,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-5",
    cx: 32.273,
    cy: 12.249,
    r: 0.074,
    gradientTransform: "matrix(1.002, 0, 0, -1.002, -0.138, 40.036)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 2725.592,
    y1: 3729.619,
    x2: 2746.547,
    y2: 3729.619,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 2725.631,
    y1: 3723.821,
    x2: 2746.421,
    y2: 3723.821,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-6",
    cx: 32.101,
    cy: 12.059,
    r: 0.043,
    gradientTransform: "matrix(1.002, 0, 0, -1.002, -0.138, 40.036)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 2725.597,
    y1: 3722.552,
    x2: 2746.544,
    y2: 3722.552,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-7",
    cx: 33.851,
    cy: 21.317,
    r: 0.363,
    gradientTransform: "matrix(1.002, 0, 0, -1.002, -0.138, 40.036)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 2742.31,
    y1: 3722.431,
    x2: 2735.756,
    y2: 3721.339,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 2742.279,
    y1: 3722.715,
    x2: 2735.694,
    y2: 3721.618,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 2741.75,
    y1: 3725.845,
    x2: 2735.165,
    y2: 3724.748,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 2741.934,
    y1: 3725.612,
    x2: 2735.263,
    y2: 3724.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 2725.581,
    y1: 3722.277,
    x2: 2746.552,
    y2: 3722.277,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 2742.273,
    y1: 3722.733,
    x2: 2735.695,
    y2: 3721.637,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 2724.921,
    y1: 3721.837,
    x2: 2746.935,
    y2: 3721.837,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 2742.503,
    y1: 3722.475,
    x2: 2735.575,
    y2: 3721.321,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-8",
    cx: 34.233,
    cy: 20.487,
    r: 0.191,
    gradientTransform: "matrix(1.002, 0, 0, -1.002, -0.138, 40.036)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 2742.292,
    y1: 3722.634,
    x2: 2735.708,
    y2: 3721.537,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-9",
    cx: 34.511,
    cy: 19.854,
    r: 0.034,
    gradientTransform: "matrix(1.002, 0, 0, -1.002, -0.138, 40.036)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 2742.304,
    y1: 3722.428,
    x2: 2735.76,
    y2: 3721.338,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 2725.589,
    y1: 3722.815,
    x2: 2746.547,
    y2: 3722.815,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-10",
    cx: 3671.494,
    cy: 3963.392,
    r: 14.161,
    gradientTransform: "matrix(1.002, 0, 0, -1.002, -0.138, 40.036)",
    xlinkHref: "#radial-gradient"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M30.43,12.846c-0.114-.194-0.233-0.395-0.36-0.6C25.346,4.92,18.746-.681,15.4.067a5.53,5.53,0,0,0-2.915,2.2,9.912,9.912,0,0,1,5.683,2.274,15.985,15.985,0,0,1,3.558,2.6c1.578,1.265,6.824,7.25,9.731,14.378,1.117,2.873,1.437,5.2.834,6.141l-0.02.03c-0.652,1.014-3.223,1.7-6.67,1.759a17.058,17.058,0,0,1-1.2,3.266c5.5,0.2,10.038-.77,11.319-2.8C37.507,27.179,35.05,19.646,30.43,12.846Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M34.465,20.18q-0.41-.967-0.9-1.962a44.824,44.824,0,0,1-1.68,4.5c0.757,2.3.919,4.132,0.4,4.934l-0.02.03a1.892,1.892,0,0,1-.536.514C33.026,27.516,35.506,26.312,34.465,20.18Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M30.827,8.885l0.025,0.028c0.832,0.929.793,3.768-.132,7.313-3.566,9.434-5.4,10.541-9.521,14.649-2.813,2.267-5.348,3.443-6.522,3.059l-0.04-.014c-0.788-.257-1.662-1.447-2.44-3.257a39.711,39.711,0,0,1-3.974-1.346c1.258,4.529,3.148,7.888,5.168,8.53,3.028,1.02,9.421-3.136,14.685-9.2,6.672-7.93,8.335-19.751,5.8-22.51C32.246,4.361,27.575,4.1,22.113,5.2a43.919,43.919,0,0,1,3.88,2.805C28.4,7.861,30.192,8.176,30.827,8.885Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M34.022,19.177l-0.028-.06a0.086,0.086,0,0,0,.013.03Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M34.427,20.1l-0.014-.03,0.012,0.027Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M34.413,20.066c-0.1-.239-0.208-0.48-0.318-0.722,0.063,0.14.123,0.279,0.184,0.418C34.323,19.859,34.37,19.965,34.413,20.066Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M34.466,20.191c1.493,3.547,2.119,6.712,1.641,8.7,0.01-.008.022-0.015,0.03-0.023,0.487-1.976-.177-5.151-1.673-8.686v0.005h0Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M33.567,18.218c0.148,0.3.29,0.6,0.428,0.9C33.857,18.819,33.716,18.52,33.567,18.218Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M34.425,20.09l-0.012-.024c-0.043-.1-0.09-0.2-0.133-0.3C34.328,19.865,34.38,19.98,34.425,20.09Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M34.425,20.09l-0.012-.024c-0.043-.1-0.09-0.2-0.133-0.3C34.328,19.865,34.38,19.98,34.425,20.09Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M32.141,27.847a1.281,1.281,0,0,0,.128-0.164A1.373,1.373,0,0,1,32.141,27.847Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M32.141,27.847a1.281,1.281,0,0,0,.128-0.164A1.373,1.373,0,0,1,32.141,27.847Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M34.466,20.191c1.035,6.122-1.441,7.326-2.733,8.006l0.013-.011c-1.113.763-3.508,1.247-6.521,1.261a44.512,44.512,0,0,1-9.01-1.626,9.065,9.065,0,0,0,.177,1.359c0.037,0.175.08,0.349,0.126,0.52,8.261,2.237,17.22,1.178,19.588-.8C36.585,26.906,35.96,23.738,34.466,20.191Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M31.989,28l0.089-.083Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M31.989,28l0.089-.083Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M33.994,19.118c-0.138-.3-0.28-0.6-0.428-0.9q0.23,0.467.441,0.929C34,19.137,34,19.127,33.994,19.118Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M33.994,19.118c-0.138-.3-0.28-0.6-0.428-0.9q0.23,0.467.441,0.929C34,19.137,34,19.127,33.994,19.118Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M34.465,20.185h0c-0.012-.029-0.026-0.056-0.037-0.085v0.007Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M34.1,19.34l-0.073-.163c0.014,0.029.025,0.057,0.038,0.086Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M31.747,28.18a2.347,2.347,0,0,0,.242-0.188A2.474,2.474,0,0,1,31.747,28.18Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M32.075,27.914c0.023-.023.044-0.045,0.063-0.067A0.485,0.485,0,0,1,32.075,27.914Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M34.06,19.264c-0.013-.028-0.024-0.057-0.038-0.086l-0.014-.03C34.026,19.186,34.042,19.224,34.06,19.264Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M34.06,19.264c-0.013-.028-0.024-0.057-0.038-0.086l-0.014-.03C34.026,19.186,34.042,19.224,34.06,19.264Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M34.429,20.1v0Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M34.429,20.1v0Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M34.28,19.759c-0.061-.139-0.121-0.278-0.184-0.418l-0.035-.077C34.136,19.429,34.207,19.594,34.28,19.759Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M34.28,19.759c-0.061-.139-0.121-0.278-0.184-0.418l-0.035-.077C34.136,19.429,34.207,19.594,34.28,19.759Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M34.466,20.191V20.185L34.43,20.1C34.442,20.132,34.453,20.161,34.466,20.191Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M34.466,20.191V20.185L34.43,20.1C34.442,20.132,34.453,20.161,34.466,20.191Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M34.466,20.191c-0.013-.03-0.024-0.059-0.037-0.088V20.091c-0.047-.109-0.1-0.22-0.145-0.332-0.072-.165-0.144-0.33-0.219-0.5-0.018-.039-0.034-0.077-0.052-0.116q-0.212-.461-0.441-0.929a44.824,44.824,0,0,1-1.68,4.5c0.757,2.3.919,4.132,0.4,4.934l-0.02.03a1.281,1.281,0,0,1-.128.164c-0.02.022-.041,0.045-0.063,0.067s-0.058.055-.089,0.083a2.347,2.347,0,0,1-.242.188l-0.013.011C33.025,27.516,35.5,26.313,34.466,20.191Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M34.466,20.191c-0.013-.03-0.024-0.059-0.037-0.088V20.091c-0.047-.109-0.1-0.22-0.145-0.332-0.072-.165-0.144-0.33-0.219-0.5-0.018-.039-0.034-0.077-0.052-0.116q-0.212-.461-0.441-0.929a44.824,44.824,0,0,1-1.68,4.5c0.757,2.3.919,4.132,0.4,4.934l-0.02.03a1.281,1.281,0,0,1-.128.164c-0.02.022-.041,0.045-0.063,0.067s-0.058.055-.089,0.083a2.347,2.347,0,0,1-.242.188l-0.013.011C33.025,27.516,35.5,26.313,34.466,20.191Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M34.063,19.27V19.263c-0.018-.039-0.034-0.077-0.052-0.116L34,19.128c-0.138-.3-0.282-0.6-0.432-0.91a44.824,44.824,0,0,1-1.68,4.5c0.757,2.3.919,4.132,0.4,4.934l-0.02.03a1.281,1.281,0,0,1-.128.164c-0.019.022-.039,0.042-0.061,0.064s-0.051.048-.077,0.073L31.991,28a2.541,2.541,0,0,1-.238.185H31.747c-0.059.04-.124,0.08-0.191,0.12l-0.051.029c-0.065.037-.133,0.072-0.2,0.107l-0.07.034c-0.071.034-.144,0.067-0.221,0.1l-0.078.031c-0.08.032-.161,0.064-0.247,0.1H30.679c-0.166.06-.347,0.115-0.534,0.168-0.058.016-.115,0.034-0.175,0.049l-0.2.049-0.241.057-0.182.038-0.3.059-0.156.028q-0.193.033-.395,0.062l-0.088.014a22.163,22.163,0,0,1-2.353.2h0q-0.321.011-.654,0.014,0.627-.744,1.24-1.531A36.715,36.715,0,0,0,33.43,9.929c0.531,0.158,1.049.331,1.54,0.527,0.029-1.94-.316-3.465-1.09-4.318-1.165-1.325-3.991-1.8-7.558-1.536l-0.106.009c-0.206.016-.415,0.035-0.627,0.056l-0.178.018c-0.207.022-.416,0.046-0.627,0.073l-0.143.017q-0.377.05-.762,0.108l-0.221.037q-0.274.044-.55,0.092l-0.321.058L22.32,5.16l-0.21.04h0a44.267,44.267,0,0,0-5.967,1.662c-0.217.061-.436,0.124-0.658,0.2C9.17,9.127,3.552,12.519,1.188,15.546l-0.018.023A6.128,6.128,0,0,0,.184,17.3l-0.006.018a3.571,3.571,0,0,0-.108.393v0.02A2.866,2.866,0,0,0,0,18.183c-0.106,1.774,1.572,4.142,4.309,6.5a7.343,7.343,0,0,1-.088-1.115A42.841,42.841,0,0,0,12.961,28.5a29.619,29.619,0,0,0,3.557,1.2v0.005c0.156,0.042.314,0.081,0.47,0.121L17.16,29.87q-0.322-.08-0.642-0.165a9.035,9.035,0,0,0,.889,2.124c0.633,0.166,1.267.31,1.9,0.435-2.021,1.336-3.731,1.968-4.634,1.672l-0.04-.016c-0.788-.257-1.662-1.447-2.44-3.257-1.195-.337-2.335-0.718-3.407-1.13l-0.548-.169c1.246,4.462,3.107,7.775,5.1,8.459,1.9,0.567,5.412-1.556,9.042-5.109,6.4,0.63,12.072-.722,13.329-2.805a3.594,3.594,0,0,0,.395-1.016c-0.08.067-.169,0.132-0.264,0.2a2.754,2.754,0,0,0,.264-0.2h0l0.03-.023C36.666,26.727,35.839,23.171,34.063,19.27Zm0.918,10.292c0.114-.052.224-0.1,0.329-0.158a8.188,8.188,0,0,1-.86.376c0.113-.042.222-0.086,0.328-0.131C34.851,29.619,34.919,29.591,34.981,29.562Zm-1.271.467,0.166-.053q0.189-.059.368-0.122-0.507.179-1.1,0.334,0.3-.076.572-0.158h0Zm-0.732.2,0.1-.025c-0.205.053-.421,0.1-0.64,0.151l0.046-.01c0.169-.038.338-0.077,0.5-0.117h0Zm-0.674.155c-0.486.1-1,.191-1.548,0.267l0.1-.013c0.511-.075,1-0.16,1.452-0.254h0Zm-2.34.369q0.391-.044.765-0.1-0.382.054-.781,0.1h0.016Zm-0.028,0c-0.57.063-1.167,0.112-1.782,0.145,0.62-.031,1.215-0.08,1.787-0.142Zm-21.22-6.78A17.924,17.924,0,0,1,4.871,20.3c-0.056-.079-0.11-0.157-0.156-0.237C4.7,20.046,4.689,20.026,4.676,20a4.982,4.982,0,0,1-.345-0.624c-0.02-.044-0.04-0.087-0.057-0.129s-0.033-.085-0.048-0.128-0.032-.094-0.046-0.14-0.021-.074-0.03-0.11c-0.013-.052-0.022-0.1-0.03-0.152a0.811,0.811,0,0,0-.013-0.086A1.392,1.392,0,0,1,4.1,18.412V18.379a1.39,1.39,0,0,1,.026-0.194,0.286,0.286,0,0,1,.014-0.063c0.011-.049.026-0.1,0.042-0.148,0.007-.023.014-0.045,0.023-0.068,0.025-.068.053-0.138,0.086-0.208,0.009-.019.02-0.039,0.03-0.059,0.027-.053.055-0.108,0.087-0.163l0.059-.1c0.02-.034.055-0.088,0.085-0.132s0.047-.072.073-0.109,0.075-.1.114-0.154,0.1-.13.155-0.2l0.081-.1c0.044-.051.09-0.1,0.137-0.156l0.07-.076c0.176-.186.375-0.387,0.592-0.587L5.8,15.836c0.078-.072.158-0.144,0.242-0.217h0q0.257-.225.544-0.455h0a21.674,21.674,0,0,1,1.838-1.309,75.784,75.784,0,0,1,16.3-5.747c0.439-.05.861-0.084,1.268-0.107h0a15.211,15.211,0,0,1,2.417.032h0.009c0.114,0.011.224,0.025,0.333,0.04h0.01a6.7,6.7,0,0,1,.883.18h0.01c0.06,0.018.117,0.037,0.174,0.056l0.106,0.035L30.071,8.4c0.04,0.016.079,0.033,0.117,0.05S30.263,8.485,30.3,8.5s0.078,0.041.115,0.062S30.474,8.6,30.5,8.62s0.077,0.053.113,0.08c0.021,0.016.043,0.031,0.063,0.047a1.4,1.4,0,0,1,.146.139l0.026,0.027a1.342,1.342,0,0,1,.154.211h0a2.077,2.077,0,0,1,.129.257c0.519,1.228.385,3.768-.417,6.839-3.028,8.015-4.806,10.018-7.8,12.957C14.984,28.161,13.308,26.678,8.716,23.973Zm12.7,6.682c-1.033-.129-2.078-0.3-3.12-0.527q0.453,0.1.907,0.181l0.142,0.027q1.036,0.189,2.066.318h0.005Zm-4.209-.777Q17.7,30,18.187,30.1l0.076,0.015q-0.533-.113-1.059-0.243h0.005Zm6.923,1.02h0q1.037,0.056,2.034.056h0.027q0.979,0,1.9-.05a37.277,37.277,0,0,1-3.971-.006h0.005ZM35.4,29.359l0.088-.048c0.071-.04.138-0.079,0.2-0.12l0.04-.026q-0.157.1-.334,0.193H35.4Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M33.567,18.218a44.824,44.824,0,0,1-1.68,4.5c0.757,2.3.919,4.132,0.4,4.934l-0.02.03c-0.675,1.05-3.407,1.749-7.044,1.764-7.7-.794-10.371-1.867-13.494-3.679-0.73-.424-1.488-0.887-2.339-1.4l-0.675-.4a20.242,20.242,0,0,1-3.358-3.045h0A4.22,4.22,0,0,1,4.1,18.417V18.379c0.043-.834.957-1.991,2.49-3.217a40.559,40.559,0,0,1,.265-4.213C2.834,13.342.105,16.052,0,18.183c-0.158,2.632,3.608,6.564,8.92,9.854l0.014,0.009q0.407,0.251.826,0.5L9.85,28.6q0.431,0.252.872,0.5l0.036,0.019q0.4,0.222.809,0.437l0.19,0.1c0.288,0.15.576,0.3,0.869,0.444L12.74,30.15h0c9.313,4.364,21.139,2.666,22.973-.239C37.039,27.888,36.041,23.246,33.567,18.218Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M14.675,33.931l-0.038-.011c-1.183-.387-2.558-2.864-3.515-6.4-1.593-9.965-.559-11.846.978-17.482,1.311-3.38,2.922-5.675,4.13-5.936L16.266,4.1c0.81-.174,2.157.416,3.728,1.59A40.157,40.157,0,0,1,24.1,4.853C20.77,1.563,17.466-.395,15.4.067,12.271,0.71,8.8,7.529,7.245,15.43,5.407,25.657,9.911,36.8,13.4,37.846c2.305,0.693,6.474-1.4,10.656-5.109a43.751,43.751,0,0,1-4.75-.47C17.284,33.6,15.577,34.226,14.675,33.931Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M15.459,0.058c-2.7.654-5.49,7.4-6.6,15.286C7.621,25.156,11.616,35.995,14.5,37.992c2.39-.045,5.971-2.085,9.549-5.259a43.751,43.751,0,0,1-4.75-.47c-2.016,1.334-3.723,1.964-4.625,1.668l-0.038-.012c-1.183-.387-2.558-2.864-3.515-6.4-1.593-9.965-.559-11.846.978-17.482,1.311-3.38,2.922-5.675,4.13-5.936L16.266,4.1c0.81-.174,2.157.416,3.728,1.59,1.2-.308,2.379-0.553,3.516-0.738l0.558-.129C20.778,1.581,17.523-.354,15.459.058Z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M22.4,34.114c0.546-.433,1.1-0.893,1.65-1.382a43.751,43.751,0,0,1-4.75-.47c-2.016,1.334-3.723,1.964-4.625,1.668l-0.039-.011a1.888,1.888,0,0,1-.631-0.388C14.995,34.613,16.792,36.714,22.4,34.114Z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M24.072,4.82L24.057,4.8A6.935,6.935,0,0,0,18,3.486a8.246,8.246,0,0,0-1.91.662c0.048-.016.1-0.034,0.143-0.045L16.27,4.1c0.81-.174,2.157.416,3.728,1.59,1.2-.308,2.379-0.553,3.516-0.738Z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M62.542,32.22h-14.6V5.866h4.377v22.66H62.542V32.22Z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M81.808,23.973H68.98A5.422,5.422,0,0,0,70.588,28a5.987,5.987,0,0,0,4.219,1.416,9.307,9.307,0,0,0,5.534-1.8v3.436a12.646,12.646,0,0,1-6.8,1.617A8.42,8.42,0,0,1,67.024,30.1q-2.362-2.564-2.362-7.213a10.025,10.025,0,0,1,2.606-7.158,8.511,8.511,0,0,1,6.462-2.766,7.418,7.418,0,0,1,5.975,2.482,10.3,10.3,0,0,1,2.115,6.892v1.638H81.808ZM77.69,20.958a5.493,5.493,0,0,0-1.084-3.575A3.625,3.625,0,0,0,73.666,16.1a4.14,4.14,0,0,0-3.116,1.341,6.128,6.128,0,0,0-1.571,3.506H77.7Z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M102.637,32.22H98.372v-10.6q0-5.275-3.732-5.275A4.076,4.076,0,0,0,91.423,17.8a5.419,5.419,0,0,0-1.269,3.685V32.22H85.871V13.4h4.283v3.125h0.073a6.715,6.715,0,0,1,6.1-3.565,5.685,5.685,0,0,1,4.689,2,8.952,8.952,0,0,1,1.618,5.762v11.5Z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M116.187,32.661a9.333,9.333,0,0,1-6.958-2.637,9.524,9.524,0,0,1-2.606-6.993,9.916,9.916,0,0,1,2.712-7.406,9.974,9.974,0,0,1,7.308-2.665,9.034,9.034,0,0,1,6.876,2.592,10.008,10.008,0,0,1,2.463,7.186,9.861,9.861,0,0,1-2.657,7.213A9.545,9.545,0,0,1,116.187,32.661Zm0.2-16.3a4.869,4.869,0,0,0-3.953,1.746,7.311,7.311,0,0,0-1.452,4.815,6.884,6.884,0,0,0,1.468,4.659,4.941,4.941,0,0,0,3.935,1.7,4.688,4.688,0,0,0,3.87-1.672,7.4,7.4,0,0,0,1.351-4.76,7.512,7.512,0,0,0-1.351-4.8,4.666,4.666,0,0,0-3.866-1.7h0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.1cc5ec3f13650e842d147b88b4e11dc4.svg";
export { ForwardRef as ReactComponent };